import { render, staticRenderFns } from "./bank-account-review-list.vue?vue&type=template&id=6131b5b9&scoped=true&lang=pug"
import script from "./bank-account-review-list.vue?vue&type=script&lang=ts"
export * from "./bank-account-review-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6131b5b9",
  null
  
)

export default component.exports